import Head from 'next/head';
import Image from 'next/image';
import { useRouter } from 'next/router';
import Layout from 'components/layout';
import Header from 'components/support/header';
import MobileButton from 'components/button';
import style from 'styles/support/announcement.module.scss';
import { pageSize } from 'constants/index';
import { action, actionServer } from 'action/index';
import { Pagination, List } from 'antd';
import cn from 'classnames';
// import useSWR, { SWRConfig } from 'swr';
import { useState, useRef } from 'react';

export default function Home({ list: l, current: c, total: t }: any) {
  return (
    <Layout>
      <Head>
        <title>支持中心-公告</title>
      </Head>
      <section className={style.container}>
        <Header pageKey="announcement" />
        <MobileList list={l} current={c} total={t} />
        <PCList list={l} current={c} total={t} />
      </section>
    </Layout>
  );
}

export async function getStaticProps() {
  const res = await actionServer.getAnnouncementList(1, pageSize);
  const fallback = {
    list: [],
    total: 0,
    current: 1,
  };
  if (res) {
    fallback.list = res.records;
    fallback.total = res.total;
  }

  return {
    props: {
      ...fallback,
    },
    revalidate: 30,
  };
}

// 子组件
const MobileList = ({ list: l, current: c, total: t }: any) => {
  const router = useRouter();
  const [list, setList] = useState(l);
  const [total, setTotal] = useState(t);
  const [loading, setLoading] = useState(false);
  const page = useRef(c);
  const onLoadMore = async () => {
    setLoading(true);
    page.current += 1;
    const res = await action.getAnnouncementList(page.current, pageSize);
    if (res) {
      const { total, records } = res;
      setTotal(total);
      setList((list: any) => [...list, ...records]);
    }
    setLoading(false);
  };

  return (
    <div className={cn(style.main, style.forMobile)}>
      <List
        className={style.mobileAnnouncement}
        // loading={initLoading}
        itemLayout="horizontal"
        loadMore={
          total > list.length && (
            <MobileButton category="viewMore" className={style.loadMore} onClick={onLoadMore} loading={loading}>
              查看更多
            </MobileButton>
          )
        }
        dataSource={list}
        renderItem={(item: any) => (
          <div className={style.item} key={item.id} onClick={() => router.push(`/v2/announcement/${item.id}`, undefined, { scroll: false })}>
            <div className={style.title}>
              <span className={style.line}></span>
              <span className={style.intro}>{item.intro}</span>
            </div>
            <div className={style.date}>
              {item.topStatus > 0 && (
                <div className={style.topWrapper}>
                  <Image className={style.top} quality={80} layout="fill" src="/v2/images/suport/m_top.png" alt="置顶" />
                </div>
              )}
              {item.releaseTime}
            </div>
          </div>
        )}
      />
    </div>
  );
};

const PCList = ({ list: l, current: c, total: t }: any) => {
  const router = useRouter();
  const [list, setList] = useState(l);
  const [total, setTotal] = useState(t);

  const onChangePage = async (page: number) => {
    const res = await action.getAnnouncementList(page, pageSize);
    if (res) {
      const { total, records } = res;
      setList(records);
      setTotal(total);
    }
  };
  return (
    <div className={cn(style.main, style.forPC)}>
      <div className={style.announcementWrapper}>
        {list.map((item: any) => {
          return (
            <div className={style.item} key={item.id} onClick={() => router.push(`/v2/announcement/${item.id}`)}>
              <span className={style.title}>
                <span className={style.intro}>{item.intro}</span>
                {item.topStatus > 0 && (
                  <div className={style.topWrapper}>
                    <Image className={style.top} width={24} height={12} quality={80} src="/v2/images/suport/pc_top@2x.png" alt="置顶" />
                  </div>
                )}
              </span>
              <span className={style.date}>{item.releaseTime}</span>
            </div>
          );
        })}
      </div>
      {total > pageSize && <Pagination showLessItems={true} className={style.pagination} total={total} defaultCurrent={c} showSizeChanger={false} pageSize={pageSize} onChange={onChangePage} />}
    </div>
  );
};
